export function formatDate(dateString) {
	const date = new Date(dateString).toISOString().split('T')[0];
	return `${date.split('-')[2]}/${date.split('-')[1]}/${date.split('-')[0]}`;
}
